import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
import _imports_0 from '../../../../resources/images/onboarding/success-folder.png';
const _hoisted_1 = { class: "onboarding-guide__settings" };
const _hoisted_2 = {
    key: 0,
    class: "d-flex mb-3"
};
const _hoisted_3 = { class: "onboarding-guide__settings-title-container" };
const _hoisted_4 = { class: "v2-title--medium-2" };
const _hoisted_5 = { class: "v2-text--small text-v2-secondary" };
import ListLabelValue from '@/components/list/list-label-value.vue';
import { computed } from 'vue';
import ArrowTopRightIcon from '@/components/icons-v2/arrow-top-right-icon.vue';
import { useAuthStore } from '@/stores/auth.ts';
import { langService } from '@/core';
export default /*@__PURE__*/ _defineComponent({
    __name: 'finish',
    props: {
        tabs: {}
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const authStore = useAuthStore();
        const lang = ((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.language) || 'en';
        const helpUrls = {
            lt: 'https://help.invoice123.com/lt',
            lv: 'https://help.invoice123.com/lv',
        };
        const url = helpUrls[lang] || 'https://help.invoice123.com/en';
        const anyCategoryCompleted = computed(() => {
            return props.tabs.some(tab => tab.categories.some(category => category.completed));
        });
        const items = computed(() => {
            return [
                lang === 'lt' && {
                    label: langService.trans('onboarding-guide.register_for_demo_call'),
                    value: ArrowTopRightIcon,
                    href: 'https://calendly.com/demo-invoice123',
                },
                {
                    label: langService.trans('onboarding-guide.useful_articles'),
                    value: ArrowTopRightIcon,
                    href: url,
                },
                {
                    label: langService.trans('module.title'),
                    value: ArrowTopRightIcon,
                    href: `${window.location.origin}/modules`,
                },
            ].filter(Boolean);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (anyCategoryCompleted.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('onboarding-guide.congrats')), 1),
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('onboarding-guide.congrats_description')), 1)
                        ]),
                        _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: _imports_0,
                            alt: "celebration",
                            class: "onboarding-guide__success-image",
                            style: { "width": "243px", "height": "200px" }
                        }, null, -1))
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(ListLabelValue, {
                    items: items.value,
                    title: _ctx.$t('onboarding-guide.learn_more')
                }, null, 8, ["items", "title"])
            ]));
        };
    }
});
